export const usersConstants = {
  GETUSERS_REQUEST: 'GETUSERS_REQUEST',
  GETUSERS_SUCCESS: 'GETUSERS_SUCCESS',
  GETUSERS_FAILURE: 'GETUSERS_FAILURE',
};
